import { childSlideToggle, childSlideUp } from '~/js/helpers';

export function initDetailsAnimation(allOpen = true) {
	document.addEventListener('click', (e) => {
		const detail = e.target.closest('details');

		// If clicked entirely outside any <details>, bail.
		if (!detail) {
			return;
		}

		const content = detail.querySelector('.details-content');
		const clickedInsideContent = content && content.contains(e.target);

		// Close other siblings if needed
		if (!allOpen) {
			const siblings = detail.parentNode?.querySelectorAll('details[open]') || [];
			siblings.forEach((sibling) => {
				if (sibling !== detail) {
					const content = sibling.querySelector('.details-content');
					childSlideUp(content);
					sibling.classList.remove('open');
				}
			});
		}

		// Only toggle when the click is NOT inside the content area
		if (!clickedInsideContent) {
			e.preventDefault();
			childSlideToggle(content);
			detail.classList.toggle('open');
		}
	});
}
